import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter, useHistory } from 'react-router-dom';
import moment from 'moment';
import Page from '../../components/Page/Page';
import { NetworkContext } from '../../context/NetworkContext';
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const STATUS_COLORS = {
  active: 'primary',
  expiring_soon: 'secondary',
  grace: 'default',
  blocked: 'default',
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3),
  },
  filter: {
    minWidth: 200,
    marginBottom: theme.spacing(2),
  },
}));

export const SubscriptionUsers = withRouter(() => {
  const classes = useStyles();
  const history = useHistory();
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [users, setUsers] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');

  async function loadUsers() {
    const result = await sendNetworkRequest('/admin/listsubscriptionusers', {}, {
      status_filter: statusFilter === 'all' ? null : statusFilter,
    }, false);
    setUsers(result?.users || []);
  }

  useEffect(() => {
    loadUsers();
  }, [statusFilter]);

  return (
    <Page className={classes.root} title="Subscription Users">
      <Typography variant="h4" gutterBottom>Subscription Overview</Typography>
      <FormControl variant="outlined" className={classes.filter}>
        <InputLabel>Status filter</InputLabel>
        <Select
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
          label="Status filter"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="expiring_soon">Expiring Soon</MenuItem>
          <MenuItem value="grace">Grace</MenuItem>
          <MenuItem value="blocked">Blocked</MenuItem>
        </Select>
      </FormControl>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>Expiry</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map(row => (
              <TableRow key={row.user_profile_id}>
                <TableCell>{row.user?.name || row.user_name}</TableCell>
                <TableCell>{row.user?.mobilenumber || row.mobile}</TableCell>
                <TableCell>{row.plan?.name || '—'}</TableCell>
                <TableCell>
                  {row.valid_from ? moment(row.valid_from).format('DD/MM/YYYY') : '—'}
                </TableCell>
                <TableCell>
                  {row.valid_until ? moment(row.valid_until).format('DD/MM/YYYY') : '—'}
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={row.status}
                    color={STATUS_COLORS[row.status] || 'default'}
                  />
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    size="small"
                    onClick={() => history.push(`/edituser/${row.user_profile_id}/1`)}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {users.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">No subscription records found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Page>
  );
});

export default SubscriptionUsers;
